export const ProductVisual = ({ product, className = "", emblemSize = "large" }) => {
  if (product?.image) {
    return (
      <img
        src={product.image.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${product.image}` : product.image}
        alt={product.name}
        className={`w-full h-full object-cover ${className}`}
      />
    );
  }
  const sizes = { small: "w-14", medium: "w-20", large: "w-28 lg:w-36" };
  return (
    <div className={`placeholder-surface w-full h-full flex flex-col items-center justify-center gap-4 p-6 ${className}`} data-testid="product-placeholder">
      <img
        src="/brand/goat-emblem.jpg"
        alt=""
        className={`${sizes[emblemSize] || sizes.large} aspect-[3/4] object-cover opacity-90 border border-capra-bronze/30 shadow-2xl shadow-black/60 relative z-10`}
      />
      <div className="relative z-10 text-center">
        <p className="text-[9px] uppercase tracking-[0.3em] text-capra-bronze/90 mb-1.5">Capra Falconeri</p>
        <p className="font-display italic text-sm text-capra-ivory/85 leading-snug max-w-[180px]">{product?.name}</p>
      </div>
    </div>
  );
};
